import 'vue-svgicon/dist/polyfill'
import Vue from 'vue'
import ElementUI from 'element-ui'
import '@/assets/styles/element_custom.scss'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import '@/assets/fonts/fonts.scss'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Clipboard from 'v-clipboard'
import * as svgicon from 'vue-svgicon'
import infiniteScroll from 'vue-infinite-scroll'
import iDalgoComponents from 'idalgo-components'
import iDalgoModules from 'idalgo-components/lib/iDalgoModules.common'
import '@/assets/styles/idalgo-components_custom.scss'

import { capitalize } from '@/services/filter'

import i18n from '@/lang'

import vueMoment from 'vue-moment'
import locale from 'moment/locale/fr'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(iDalgoComponents)
Vue.use(iDalgoModules, {
  env: process.env.NODE_ENV || 'dev'
})
Vue.use(vueMoment, {
  locale
})
Vue.use(Clipboard)
Vue.use(svgicon)
Vue.use(infiniteScroll)

Vue.filter('capitalize', capitalize)

router.beforeEach((to, from, next) => {
  // Request with token inside
  if (!to.matched.some(record => record.meta.requiresAuth)) {
    next()
  } else if (store.getters['auth/isLoggedIn']) {
    next()
  } else {
    store.dispatch('auth/logout')
  }
  // reinitialize document's title
  document.title = i18n.t('head.title')
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js